import { render, staticRenderFns } from "./SectionWeddingMenu.vue?vue&type=template&id=54777ad4&scoped=true&"
import script from "./SectionWeddingMenu.vue?vue&type=script&lang=js&"
export * from "./SectionWeddingMenu.vue?vue&type=script&lang=js&"
import style0 from "./SectionWeddingMenu.vue?vue&type=style&index=0&id=54777ad4&scoped=true&lang=stylus&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "54777ad4",
  null
  
)

export default component.exports